import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CircleDot, Menu, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/beliefs', label: 'Beliefs' },
    { path: '/practice', label: 'Practice' },
    { path: '/prayer', label: 'Prayer' },
    { path: '/codex', label: 'Codex' },
    { path: '/about', label: 'About' },
    { path: '/support', label: 'Support' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className="header">
      <div className="container header-content">
        <Link to="/" className="logo">
          <CircleDot size={28} className="logo-icon" />
          <span className="logo-text">Cosmergence</span>
        </Link>

        <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            {navLinks.map(link => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;